import Image from "next/image";
import { useRouter } from "next/router";
import { useState, useEffect } from "react";
import { TYPO } from "styles/Typo";
import StrategyAlarmButton from "./AlarmButton";
import { STRATEGY_TYPE } from "utils/constant/STATUS";

function StrategyHeader({ sCode }: { sCode: STRATEGY_TYPE }) {
  const router = useRouter();
  return (
    <div
      className={`h-14 py-[3px] relative w-full flex justify-center items-center `}
    >
      <div
        className="back absolute top-[50%] left-[4px] translate-y-[-50%] p-3 cursor-pointer"
        onClick={() => {
          router.push("/");
        }}
      >
        <Image
          src={"/images/icons/back.svg"}
          alt="arrow"
          width={24}
          height={24}
        />
      </div>
      <span className={`${TYPO.TYPO6_SB} text-gray80`}>
        {/* {router.locale === "ko" ? "전략" : "Investment Strategy"} */}
        따라하면 돈 버는 전략
      </span>
      <div className="back absolute top-[50%] right-[4px] translate-y-[-50%] p-3 cursor-pointer">
        <StrategyAlarmButton sCode={sCode} />
      </div>
    </div>
  );
}

export default StrategyHeader;
